import { addYears, differenceInSeconds, formatDistanceToNowStrict, secondsToMilliseconds } from 'date-fns';
import { ref, watch } from 'vue';

import { IS_DEBUG_MODE } from '@/js/constants';

import { reloadTimes } from './useTraceScheduledPostBug';

const refreshTime = ref(addYears(Date.now(), 10).getTime());
const timerId = ref<ReturnType<typeof setTimeout> | null>(null);
const debuggerIntervalId = ref<ReturnType<typeof setInterval> | null>(null);

export const setRefreshTime = (timestamp: number) => {
  refreshTime.value = timestamp;
};

watch(refreshTime, () => {
  if (timerId.value) {
    clearTimeout(timerId.value);
  }

  const exactTimeoutSeconds = Math.max(0, differenceInSeconds(refreshTime.value, Date.now()));
  const randomOffsetSeconds = Math.round(Math.random() * 31) + 1; // 1 ~ 31

  // ref: https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
  const MAX_TIMEOUT_DELAY = 2147483647;
  const timeoutInMilliseconds = Math.min(
    secondsToMilliseconds(exactTimeoutSeconds + randomOffsetSeconds),
    MAX_TIMEOUT_DELAY,
  );
  timerId.value = setTimeout(() => {
    reloadTimes.value += 1;
    if (reloadTimes.value <= 3) {
      location.reload();
    }
  }, timeoutInMilliseconds);

  if (IS_DEBUG_MODE) {
    if (debuggerIntervalId.value) {
      clearInterval(debuggerIntervalId.value);
    }
    const exactTimestampToRefresh = Date.now() + timeoutInMilliseconds;
    debuggerIntervalId.value = setInterval(() => {
      console.warn(
        'This page will refresh after',
        formatDistanceToNowStrict(exactTimestampToRefresh),
      );
    }, 5000);
  }
});
